import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
/*
 * @TODO: Request a new Icon
 * @see [WFICON-12] {@link https://jira.ttt-sp.com/browse/WFICON-12}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a assignment to a car passenger icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <AssignmentPassengerCarIcon width={12} />
 */
const AssignmentPassengerCarIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M19,3h-4.18C14.4,1.84,13.3,1,12,1S9.6,1.84,9.18,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,
        2-2V5C21,3.9,20.1,3,19,3z M13,4c0,0.55-0.45,1-1,1s-1-0.45-1-1c0-0.55,0.45-1,1-1S13,3.45,13,4z M18,13v1.33v2v1.33
        c0,0.37-0.3,0.67-0.67,0.67h-0.67c-0.37,0-0.67-0.3-0.67-0.67V17H8v0.67c0,0.37-0.3,0.67-0.67,0.67H6.67C6.3,
        18.33,6,18.03,6,17.67v-1.33v-2V13c0-0.37,0.21-0.88,0.47-1.14l0.39-0.39c0.26-0.26,0.58-0.75,
        0.72-1.09l0.84-2.1c0.14-0.34,0.55-0.62,0.91-0.62h5.33c0.37,0,0.78,0.28,0.91,0.62l0.84,2.1c0.14,0.34,
        0.46,0.83,0.72,1.09l0.39,0.39C17.79,12.12,18,12.63,18,13z M8.67,14c0,0.55-0.45,1-1,1c-0.55,0-1-0.45-1-1c0-0.55,
        0.45-1,1-1C8.22,13,8.67,13.45,8.67,14z M14,15.33c0,0.18-0.15,0.33-0.33,0.33h-3.33
        c-0.18,0-0.33-0.15-0.33-0.33S10.15,15,10.33,15h3.33C13.85,15,14,15.15,14,15.33z M15.67,11.67H8.33c-0.18,
        0-0.27-0.14-0.2-0.3L9.2,8.97c0.07-0.17,0.29-0.3,0.47-0.3h4.67c0.18,0,0.39,0.14,0.47,
        0.3l1.06,2.39C15.94,11.53,15.85,11.67,15.67,11.67z M17.33,14
        c0,0.55-0.45,1-1,1c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1C16.89,13,17.33,13.45,17.33,14z`}
        />
    </SvgIcon>
)

AssignmentPassengerCarIcon.defaultProps = defaultProps

export { AssignmentPassengerCarIcon }
